import { TranslationsStatus } from "../../typings/translations";
import { postMessageToV2 } from "../../utils/sale-iframe";

export class TranslationsDialogController {
    public static $inject: string[] = ["$log", "$mdDialog", "$scope", "$translate", "toaster", "translationsService"];

    // locals
    public getTranslationStatus: Function;
    public setTranslationStatus: Function;
    public fetchAll: Function;
    public initiatePublish: Function;
    public isPublishDisabled: boolean;
    public currentLocale: string;
    public resourceId: number;

    private $t;

    constructor(
        private $log: ng.ILogService,
        $mdDialog: ng.material.IDialogService,
        private $scope,
        $translate: ng.translate.ITranslateService,
        private toaster,
        private translationsService
    ) {
        this.$t = $translate;

        $scope.closeDialog = () => $mdDialog.hide();

        $scope.publishAnyway = event => {
            this.initiatePublish({
                checkTranslationStatus: false,
                event,
                resourceId: this.resourceId
            }).finally(() => this.fetchAll({ checkSaleTranslationStatus: false }));
        };

        $scope.$watch(
            () => this.$scope.translationsStatus?.status,
            current => {
                if (current === TranslationsStatus.Done) {
                    $mdDialog.hide({ isTranslationDone: true });
                }
            }
        );
    }

    public $onInit() {
        this.setTranslationStatus({ ...this.$scope.translationsStatus, status: TranslationsStatus.Needed });
    }

    public postTranslations() {
        this.setTranslationStatus({ ...this.$scope.translationsStatus, status: TranslationsStatus.Pending });

        this.translationsService
            .postTranslations(this.resourceId)
            .then(async () => {
                await this.getTranslationStatus();
                postMessageToV2({ saleId: this.resourceId });
            })
            .catch(e => {
                this.$log.error("Unable to translate resource", e);
                this.toaster.show(this.$t("une_erreur_est_survenue_veuillez_reessayer"), true);
                this.setTranslationStatus({ ...this.$scope.translationsStatus, status: TranslationsStatus.Error });
            });
    }
}
